import {
  ACTION_PUT_ORG_BANK_ACCOUNT,
  ACTION_PUT_ORG_BANK_ACCOUNT_SUCCESS,
  ACTION_PUT_ORG_BANK_ACCOUNT_FAILURE,
  ACTION_RESET_ORG_BANK_ACCOUNT_ERROR,
  API_CALL,
} from '../../../configs/ActionTypes';
import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../../Status';
import * as _ from 'lodash-es';

export function putBankAccountSetting(organizationId: any, data: any) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());
    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/bank-account`,
        method: 'PUT',
        data: JSON.stringify(data),
        success: (response: any) => {
          if (response.type === 'error') {
            dispatch(requestFailed(response));
            _.get(response.payload, 'payload.userPermissionError', false)
              ? enqueueSnackbarHandler(
                  dispatch,
                  response.payload.payload,
                  'error',
                )
              : enqueueSnackbarHandler(
                  dispatch,
                  { addBankAccountSettingFailed: true },
                  'error',
                );
          } else {
            enqueueSnackbarHandler(
              dispatch,
              { addBankAccountSetting: true },
              'success',
            );
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
          _.get(error.payload, 'userPermissionError', false)
            ? enqueueSnackbarHandler(dispatch, error.payload, 'error')
            : enqueueSnackbarHandler(
                dispatch,
                { addBankAccountSettingFailed: true },
                'error',
              );
        },
      },
    });
    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_PUT_ORG_BANK_ACCOUNT,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_PUT_ORG_BANK_ACCOUNT_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_PUT_ORG_BANK_ACCOUNT_FAILURE,
    payload: responseJSON,
  };
}

export function resetBankAccountError() {
  return (dispatch: Dispatch, getState: Function) => {
    // Dispatch the api call request.
    dispatch({
      type: ACTION_RESET_ORG_BANK_ACCOUNT_ERROR,
      payload: null,
    });
  };
}
